import { portNumbers } from 'get-port'

export const config = {
  projects: {
    dashboard: process.env.DASHBOARD_URL ?? 'https://dashboard.scalar.com',
    sandbox: process.env.SANDBOX_URL ?? 'https://sandbox.scalar.com',
  },
  services: {
    api: process.env.SCALAR_API ?? 'https://api.scalar.com',
  },
  auth: {
    callback: {
      preferredPortRange: process.env.PREFERRED_PORT
        ? Number.parseInt(process.env.PREFERRED_PORT)
        : portNumbers(4799, 5100),
    },
  },
} as const
